import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { OtpComponent } from 'authentication/components/otp/otp.component';
import { PasswordInputComponent } from 'shared/components';
import { FormErrorComponent } from 'shared/components/form-error/form-error.component';
import { TimerComponent } from 'shared/components/timer/timer.component';
import { LoginComponent } from './components';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'shared/shared.module';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { ForgotPasswordFormComponent } from './components/forgot-password-form/forgot-password-form.component';
import { RouterModule } from '@angular/router';
import { ResetPasswordFormComponent } from './components/reset-password-form/reset-password-form.component';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { RequiredPasswordChangeComponent } from './components/required-password-change/required-password-change.component';

@NgModule({
    declarations: [
        LoginComponent,
        LoginFormComponent,
        ForgotPasswordFormComponent,
        ResetPasswordFormComponent,
        RequiredPasswordChangeComponent,
    ],
    exports: [AuthenticationRoutingModule],
    imports: [
        CommonModule,
        TranslateModule,
        SharedModule,
        RouterModule,
        FormErrorComponent,
        PasswordInputComponent,
        TimerComponent,
        OtpComponent,
        NgOptimizedImage,
    ],
    providers: [],
})
export class AuthenticationModule {}
